import { render, staticRenderFns } from "./GateParameters.vue?vue&type=template&id=0bc4b838&scoped=true&"
import script from "./GateParameters.vue?vue&type=script&lang=js&"
export * from "./GateParameters.vue?vue&type=script&lang=js&"
import style0 from "./GateParameters.vue?vue&type=style&index=0&id=0bc4b838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc4b838",
  null
  
)

export default component.exports